<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="w-full">
                <div class="mt-12" v-if="addReportingManagerDiv">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between">
                            <p class="font-semibold text-xl text-neutral-800">Add Reporting Manager</p>
                        </div>
                        <div class=" overflow-x-auto sm:rounded-lg pt-5">
                            <form v-on:submit.prevent="submitForm" ref="form" name="form">
                                <div class="addNewBox1" >
                                    <div class="addNewSub" >
                                        <div class="addNewFirst adnright" >
                                            <label>Reporting Manager Name:</label>
                                            <input class="addNewInput" type="text" v-model="reportingManagerName" placeholder="Reporting Manager Name">
                                            <p class="text-red-600" v-if="fieldMissing">This field is required</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4 text-right">
                                    <button type="button" class="ml-auto mr-2 btn-gray-light" @click="this.addReportingManagerDiv = false">
                                        <span class="pr-2">
                                            Cancel 
                                        </span>
                                    </button>
                                    <button type="submit" class=" btn-primary-light flex items-center" :disabled="buttonclick" :class="buttonclick == true ? 'opacity-50 cursor-not-allowed' : ''">
                                        <span class="pr-2">
                                            Submit 
                                        </span>
                                        <span>
                                            <span v-if="this.btnLoader" class="animate-spin h-4 w-4 inline-block border-2 border-white border-r-white/10 border-t-white/10 rounded-full"></span>
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between">
                            <p class="font-semibold text-xl text-neutral-800">Reporting Manager List</p>
                            <div class="flex items-center">
                                                             
                                <button v-if="!addReportingManagerDiv" class="ml-3 btn-primary-light flex items-center"  @click="this.addReportingManagerDiv = true">
                                    <span class="pl-2">
                                        Add Reporting Manager
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class=" overflow-x-auto sm:rounded-lg pt-5">
                            <table v-if="isLoading" class="w-full text-sm text-left text-neutral-500 ">
                                <thead class="text-xs bg-neutral-300/50 uppercase animate-pulse">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="animate-pulse">
                                    <tr class="bg-white border-b border-neutral-100" v-for="i in 5" :key="i">
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                    </tr>                                 
                                </tbody>
                            </table>
                            <table v-else class="glob_table w-full text-sm text-left text-neutral-500">
                                <thead class="bg-[#ECF6FF]">
                                    <tr>
                                        <th scope="col" class="px-3 py-2 font-semibold">
                                            ID
                                        </th>
                                        <th scope="col" class="px-3 py-2 font-semibold">
                                            Reporting Manager Name
                                        </th>
                                        <!-- <th scope="col" class="px-3 py-2 font-semibold">
                                            Country Code
                                        </th> -->
                                        <!-- <th scope="col" class="px-3 py-2 font-semibold">
                                            Status
                                        </th> -->
                                        <th scope="col" class="px-3 py-2 font-semibold">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(reportingManager,index) in reportingManagerList" :key="reportingManager.id" :class="(reportingManager.editDiv)? 'update':''" class="bg-white border-b">
                                        <td scope="row" class="px-3 py-2 font-medium text-neutral-700 whitespace-nowrap">
                                            #{{ index+1 }}
                                        </td>
                                        <td class="px-3 py-2">
                                            <div v-if="!reportingManager.editDiv" class="flex items-center">{{ reportingManager.name }}</div>
                                            <div v-else class="flex items-center">
                                                <input type="text" v-model="reportingManager.name" class="form-control" placeholder="Enter Reporting Manager Name"/>
                                            </div>
                                        </td>
                                        <!-- <td class="px-3 py-2">
                                            <b  :class="(reportingManager.status=='A')? 'green':'red'">{{ (reportingManager.status=='A')? 'Active':'Inactive'}}</b>
                                        </td> -->
                                        <td class="px-3 py-2">
                                            <div class="flex items-center space-x-1">
                                                <button v-if="!reportingManager.editDiv" type="button" v-on:click="clickToEdit(reportingManager)" class="border mr-2 rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                    </svg>
                                                </button>
                                                <button v-if="!reportingManager.editDiv" type="button" @click="deleteReportingManager(reportingManager.id)" class="border rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                    </svg>
                                                </button>
                                                <button v-if="reportingManager.editDiv" v-on:click="editReportingManager(reportingManager.id,reportingManager.name),clickToEdit(reportingManager)" class="border mr-2 rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                                                    </svg>

                                                </button>
                                                <button v-if="reportingManager.editDiv" v-on:click="clickToEdit(reportingManager)" class="border rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <RightSideBar/>
        </section>
    </AdminLayout>
</template>
<script>
    import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    // import RightSideBar from '../../components/RightSideBar.vue';
    import axios from "axios";
    import { BASE_URL } from "../../config";
    import { createLocal } from 'the-storages';
    import { createToast } from 'mosha-vue-toastify';
    const mirror = createLocal();
    const storage = mirror._prx;


    export default {
        name: 'CountryList',
        components:{
            AdminLayout,
            // RightSideBar
        },
        data() {
            return {
                storage:storage,
                reportingManagerList: [],
                addReportingManagerDiv:false,
                reportingManagerName:'',
                fieldMissing:false,
                isLoading: false,
                buttonclick: false,
                btnLoader: false,
            }
        },
        created(){
            this.getReportingManagerList();
        },
        methods:{
            async getReportingManagerList() {
        this.isLoading = true; // ✅ Start loader
        
        try {
            const formData = {
                company_id: this.storage.companyDetails.id
            };
            const response = await axios.post(BASE_URL + '/reporting-manager-list', formData);
            this.reportingManagerList = response.data.reportingManagerList;
            console.log("REPORTING MANAGER LIST:: ", response.data);
        } catch (error) {
            console.error("Error fetching reporting manager list:", error);
        } finally {
            this.isLoading = false; // ✅ Stop loader
        }
    },
            async submitForm() {
                if(this.reportingManagerName == '') {
                    this.fieldMissing = true;
                    return false;
                } else {
                    this.fieldMissing = false;
                }

                const formData = {
                    "company_id":this.storage.companyDetails.id,
                    "reportingManagerName":this.reportingManagerName,
                    "ipAddress": this.storage.ipAddress
                };
                this.btnLoader = true;
                this.buttonclick = true;
                await axios.post(BASE_URL + '/add-reporting-manager',formData)
                .then((response)=>{
                    console.log("DEPARTMENT DATA:: ",response.data);
                    this.addReportingManagerDiv = false;
                    this.reportingManagerName = '';
                    this.getReportingManagerList();
                    if(response.data.success === 'success'){
                        this.btnLoader = false;
                        this.buttonclick = false;
                        this.tostMessage('success', response.data.message);
                    }else{
                        this.btnLoader = false;
                        this.buttonclick = false;
                        this.tostMessage('danger', response.data.message);
                    }
                })
            },
         
            clickToEdit(reportingManager){
                reportingManager.editDiv = !reportingManager.editDiv; // Toggle the editable stat
            },
            async editReportingManager(id,name){
                    const formData = {
                        "id": id,
                        "reportingManagerName": name
                    };
                    console.log("data:",formData);
                    await axios.put(BASE_URL + '/edit-reporting-manager',formData)
                    .then((response)=>{
                        console.log(response.data);
                        this.getReportingManagerList();
                    })
              
            },
            async deleteReportingManager(id){
                if (id) {
                    const formData = {
                        "id": id,
                        "company_id":this.storage.companyDetailsid,
                    };
                    // console.log("data:",formData);
                    await axios.post(BASE_URL + '/delete-reporting-manager',formData)
                    .then((response)=>{
                        // console.log("DELETE RES",response.data);                        
                        if(response.data.success === 'success'){                           
                           this.tostMessage('success', response.data.message);
                           this.getReportingManagerList();
                        }else{                           
                            this.tostMessage('danger', response.data.message);
                        }
                    })
                } else {
                    console.log("addNewDepartment: must be value");
                }
            },

            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                type: status,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: 'true'
                })
            },

        }
    }
</script>
<style>
    .update.bg-white.border-b{
        /* border: 1px solid black; */
        border-radius: 123px !important;
        background: #eff6ff;
    }
    .green {
        color: aquamarine;
    }
    .red {
        color: rgb(253, 164, 164);
    }
    .addNewBox1 .addNewSub .adnright, .addNewBox1 {
        padding: 0px;
        margin:0px;
    }
    .addNewBox1 .addNewSub .adnright, .addNewBox1 .addNewSub .adnleft {
        flex: 1 0 50%;
    }
    .addNewBox1 .addNewSub textarea, .addNewBox1 .addNewSub select, .addNewBox1 .addNewSub input {
        border: none;
        background-color: #f5f5f5;
        padding: 12px 15px;
        display: block;
        width: 100%;
        font-size: 13px;
        color: #666;
        resize: none;
        font-weight: 500;
        border-radius: 4px;
    }
    .addNewBox1 .addNewSub label {
        font-size: 15px;
        font-weight: 500;
        color: #3c3c3c;
        margin-bottom: 2px;
    }
</style>